import { Button, Card, Modal, Select, Table } from "antd"
import type { ColumnsType } from "antd/es/table"
import React, { useEffect, useState } from "react"

import { getUsers } from "../../../TeamManagementPage/api/services.ts"
import * as services from "../../api/services.ts"

interface TeamAssignment {
  id: string
  user: { id: string; first_name: string; last_name: string; email: string }
  label: { id: number; name: string; code: string } | null
}

export const BranchTeamTab = ({ branchId }: { branchId: string }) => {
  const [members, setMembers] = useState<TeamAssignment[]>([])
  const [loading, setLoading] = useState(false)
  const [addOpen, setAddOpen] = useState(false)
  const [userOptions, setUserOptions] = useState<
    { value: string; label: string }[]
  >([])
  const [selectedUser, setSelectedUser] = useState<string | null>(null)

  const load = async () => {
    setLoading(true)
    const response = await services.getBranchTeam(branchId)
    if (response.ok) setMembers(response.data)
    setLoading(false)
  }

  useEffect(() => {
    load()
  }, [branchId])

  const openAdd = async () => {
    const response = await getUsers({ page_size: 200 })
    if (response.ok) {
      setUserOptions(
        (response.data?.results || []).map((u: any) => ({
          value: u.id,
          label: `${u.first_name} ${u.last_name} (${u.email})`
        }))
      )
    }
    setAddOpen(true)
  }

  const assign = async () => {
    if (!selectedUser) return
    await services.assignBranchMember(branchId, { user_id: selectedUser })
    setAddOpen(false)
    setSelectedUser(null)
    load()
  }

  const columns: ColumnsType<TeamAssignment> = [
    {
      title: "Name",
      render: (_, record) =>
        `${record.user.first_name} ${record.user.last_name}`
    },
    { title: "Email", dataIndex: ["user", "email"] },
    {
      title: "Role in this branch",
      render: (_, record) => record.label?.name || "—"
    }
  ]

  return (
    <Card
      title="Team members with access to this branch"
      extra={<Button onClick={openAdd}>Assign team member</Button>}
    >
      <Table
        rowKey="id"
        loading={loading}
        columns={columns}
        dataSource={members}
        pagination={false}
      />
      <Modal
        title="Assign team member to this branch"
        open={addOpen}
        onCancel={() => setAddOpen(false)}
        onOk={assign}
        okButtonProps={{ disabled: !selectedUser }}
      >
        <Select
          className="w-full"
          showSearch
          placeholder="Select a team member"
          value={selectedUser}
          onChange={setSelectedUser}
          options={userOptions}
          filterOption={(input, option) =>
            (option?.label as string)
              .toLowerCase()
              .includes(input.toLowerCase())
          }
        />
      </Modal>
    </Card>
  )
}
